import Vue from 'vue'
import VueRouter from 'vue-router'
import VueRouterBackButton from 'vue-router-back-button'
import store from '../store'

// Guards
import guestGuard from '@/router/guards/guestGuard'
import authGuard from '@/router/guards/authGuard'
import oauthGuard from '@/router/guards/oauthGuard'
import appGuard from './guards/appGuard'

// Common components
import Auth from '@/pages/auth'
import LoginPage from '@/pages/auth/LoginPage'
import RegisterPage from '@/pages/auth/RegisterPage'
import RestorePasswordPage from '@/pages/auth/RestorePasswordPage'
import PageNotFound from '@/pages/PageNotFound'
import TermsPage from '@/pages/TermsPage'
import ProfilePage from '@/pages/profile/ProfilePage'
import ProfilePreviewPage from '@/pages/profile/ProfilePreviewPage'
import ProfileBookmarksPage from '@/pages/profile/ProfileBookmarksPage'
import ProfileNotesPage from '@/pages/profile/ProfileNotesPage'
import ProfileNotePage from '@/pages/profile/ProfileNotePage'
import ProfileAddNotePage from '@/pages/profile/ProfileAddNotePage'

//Protected components
import Home from '@/pages/Home'
import Post from '@/pages/post/PostPage'
import NewPost from '@/pages/post/PostCreatePage'
import EditPost from '@/pages/post/PostEditPage'
import SettingsPage from '@/pages/SettingsPage'
import SupportPage from '@/pages/SupportPage'
import Event from '@/pages/event/EventPage.vue'
import WelcomePage from '@/pages/auth/WelcomePage.vue'
import EventsPage from '@/pages/event/EventsPage'
import AgendasPage from '@/pages/event/AgendasPage'
import MyAgendasPage from '@/pages/event/MyAgendasPage'
import PartnersPage from '@/pages/event/PartnersPage'
import AttendeesPage from '@/pages/event/AttendeesPage'
import CategoriesPage from '@/pages/forum/CategoriesPage'
import ForumsPage from '@/pages/forum/ForumsPage'
import UsersPage from '@/pages/user/UsersPage'
import DirectoriesPage from '@/pages/directory/DirectoriesPage'
import DirectoryPage from '@/pages/directory/DirectoryPage'
import ForumPage from '@/pages/forum/ForumPage'
import SpeakerPage from '@/pages/user/SpeakerPage'
import EventSpeakersPage from '@/pages/event/EventSpeakersPage'
import ExhibitorPage from '@/pages/event/ExhibitorPage'
import ExhibitorFilesPage from '@/pages/event/ExhibitorFilesPage'
import RssPage from '@/pages/rss/RssPage'

import SpeakerSessionsPage from '@/pages/user/SpeakerSessionsPage'

import SessionFilesPage from '@/pages/event/SessionFilesPage'
import SessionSpeakersPage from '@/pages/event/SpeakersPage'
import QuestionsPage from '@/pages/event/QuestionsPage'

import ResourcesPage from '@/pages/ResourcesPage.vue'
import ResourcePage from '@/pages/ResourcePage.vue'
import ResourceFilePage from '@/pages/ResourceFilePage.vue'
import Oauth2Callback from '@/pages/Oauth2Callback.vue'
import UserPage from '@/pages/user/UserPage'
import SessionPage from '@/pages/event/SessionPage'
import EventActionPage from '@/pages/event/ActionResourcePage.vue'

Vue.use(VueRouter)

const guestRoutes = [
	{
		path: '/auth',
		component: Auth,
		meta: {
			layout: 'guest',
		},
		beforeEnter: guestGuard,
		children: [
			{
				path: '',
				name: 'auth',
				redirect: 'welcome',
			},
			{
				path: 'welcome',
				name: 'welcome',
				component: WelcomePage,
			},
			{
				path: 'login',
				name: 'login',
				component: LoginPage,
			},
			{
				path: 'registration',
				name: 'registration',
				component: RegisterPage,
			}
		],
	},
	{
		path: '/terms-and-privacy',
		name: 'terms-and-privacy',
		meta: {
			layout: 'app',
		},
		component: TermsPage,
	},
	{
		path: '/oauth2-callback',
		name: 'oauth2-callback',
		meta: {
			layout: 'app',
		},
		component: Oauth2Callback,
		beforeEnter: oauthGuard,
	},
	{
		path: '*',
		name: 'page-not-found',
		meta: {
			layout: 'app',
			sidebar: false,
		},
		component: PageNotFound,
	},
]

const authRoutes = [
	{
		path: '/',
		component: Home,
		redirect: 'threads',
		beforeEnter: authGuard,

		children: [
			{
				path: '/threads',
				name: 'threads',
				meta: {
					layout: 'app',
					sidebar: true
				},
				component: Home,
			},
		],
	},
	{
		path: '/profile',
		name: 'profile',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		beforeEnter: authGuard,
		component: ProfilePage
	},
	{
		path: '/profile/notes',
		name: 'profile-notes',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		beforeEnter: authGuard,
		component: ProfileNotesPage
	},
	{
		path: '/profile/notes/add',
		name: 'profile-notes-add',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		beforeEnter: authGuard,
		component: ProfileAddNotePage
	},
	{
		path: '/profile/notes/:id',
		name: 'profile-note-by-id',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		beforeEnter: authGuard,
		component: ProfileNotePage
	},
	{
		path: '/profile/bookmarks',
		name: 'profile-bookmarks',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		beforeEnter: authGuard,
		component: ProfileBookmarksPage
	},
	{
		path: '/profile-pre-view',
		name: 'profile-pre-view',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		beforeEnter: authGuard,
		component: ProfilePreviewPage
	},
	{
		path: '/events',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		name: 'events',
		beforeEnter: authGuard,
		component: EventsPage,
	},
	{
		path: '/users',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		name: 'users',
		beforeEnter: authGuard,
		component: UsersPage,
	},
	{
		path: '/directory',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		name: 'directory',
		beforeEnter: authGuard,
		component: DirectoriesPage,
	},
	{
		path: '/directories/:id',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		name: 'directory-by-id',
		beforeEnter: authGuard,
		component: DirectoryPage,
	},
	{
		path: '/users/:id',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		name: 'user-by-id',
		beforeEnter: authGuard,
		component: UserPage,
	},
	{
		path: '/resources',
		meta: {
			layout: 'app',
			sidebar: true
		},
		name: 'resources',
		beforeEnter: authGuard,
		component: ResourcesPage,
	},
	{
		path: '/resources/:id',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		name: 'resource',
		beforeEnter: authGuard,
		component: ResourcePage,
	},
	{
		path: '/resource/:id',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		name: 'resource-file',
		beforeEnter: authGuard,
		component: ResourceFilePage,
	},
	{
		path: '/events/:id/agenda',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		name: 'agenda-events',
		beforeEnter: authGuard,
		component: AgendasPage,
	},
	{
		path: '/events/:id/my-agenda',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		name: 'my-agenda-events',
		beforeEnter: authGuard,
		component: MyAgendasPage,
	},
	{
		path: '/events/:eventId/sessions/:sessionId',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		name: 'event-session-by-id',
		beforeEnter: authGuard,
		component: SessionPage,
	},
	{
		path: '/events/:eventId/event-actions/:actionId',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		name: 'event-actions-by-id',
		beforeEnter: authGuard,
		component: EventActionPage,
	},
	{
		path: '/events/:eventId/sessions/:sessionId/speakers',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		name: 'event-session-speakers',
		beforeEnter: authGuard,
		component: SessionSpeakersPage,
	},
	{
		path: '/events/:eventId/sessions/:sessionId/questions',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		name: 'event-session-questions',
		beforeEnter: authGuard,
		component: QuestionsPage,
	},
	{
		path: '/events/:eventId/sessions/:sessionId/files',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		name: 'event-session-files',
		beforeEnter: authGuard,
		component: SessionFilesPage,
	},
	{
		path: '/speakers/:id',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		name: 'speaker-by-id',
		beforeEnter: authGuard,
		component: SpeakerPage,
	},
	{
		path: '/speakers/:id/sessions/:type',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		name: 'speaker-sessions',
		beforeEnter: authGuard,
		component: SpeakerSessionsPage,
	},
	{
		path: '/events/partner/:id',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		props: (route) => ({ name: route.params.name, id: route.params.id }),
		name: 'partner-events',
		beforeEnter: authGuard,
		component: PartnersPage,
	},
	{
		path: '/events/attendees/:id',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		name: 'attendees-events',
		beforeEnter: authGuard,
		component: AttendeesPage,
	},
	{
		path: '/event/:id',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		name: 'event-by-id',
		beforeEnter: authGuard,
		component: Event,
	},
	{
		path: '/event/:id/speakers',
		meta: {
			layout: 'app',
			sidebar: true
		},
		name: 'event-speakers',
		beforeEnter: authGuard,
		component: EventSpeakersPage
	},
	{
		path: '/exhibitor/:id',
		meta: {
			layout: 'app',
			sidebar: true
		},
		name: 'exhibitor-by-id',
		beforeEnter: authGuard,
		component: ExhibitorPage
	},
	{
		path: '/exhibitor/:id/files',
		meta: {
			layout: 'app',
			sidebar: true
		},
		name: 'exhibitor-files-by-id',
		beforeEnter: authGuard,
		component: ExhibitorFilesPage
	},
	{
		path: '/forums',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		name: 'forums',
		beforeEnter: authGuard,
		component: CategoriesPage,
	},
	{
		path: '/forums/:id',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		name: 'forum-by-id',
		beforeEnter: authGuard,
		component: ForumPage,
	},
	{
		path: '/forums-category/:id',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		name: 'forums-by-category-id',
		beforeEnter: authGuard,
		component: ForumsPage,
	},
	{
		path: '/thread/:id',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		name: 'posts-by-id',
		beforeEnter: authGuard,
		component: Post,
	},

	{
		path: '/post/create',
		meta: {
			layout: 'app',
			sidebar: false,
		},
		name: 'CreatePost',
		beforeEnter: authGuard,
		component: NewPost,
	},
	{
		path: '/post/:id/edit',
		meta: {
			layout: 'app',
			sidebar: false,
		},
		name: 'EditPost',
		beforeEnter: authGuard,
		component: EditPost,
	},
	{
		path: '/rss',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		name: 'rss-feed',
		beforeEnter: authGuard,
		component: RssPage
	},
	{
		path: '/settings',
		meta: {
			layout: 'app',
			sidebar: true,
		},
		name: 'settings',
		component: SettingsPage,
		beforeEnter: authGuard,
	},
	{
		path: '/support',
		meta: {
			layout: 'app',
			sidebar: false,
		},
		component: SupportPage,
		beforeEnter: authGuard,
	}
]

const routes = [...authRoutes, ...guestRoutes]

const router = new VueRouter({
	mode: 'history',
	base: process.env.VUE_APP_PUBLIC_PATH,
	routes,
})

store.watch(
	(state) => state.settings.login,
	(newRoute) => {
		if (newRoute && newRoute.forgot_password_url) {
			const regex = /\/\/(.+)/;
			const match = newRoute.forgot_password_url.match(regex);
			if (match) {
				const newPath = `/auth/${match[1]}`;

				router.options.routes.push({
					path: newPath,
					name: 'restore-password',
					component: RestorePasswordPage
				});

				const newRouter = new VueRouter({
					mode: 'history',
					base: process.env.VUE_APP_PUBLIC_PATH,
					routes: router.options.routes
				});
				router.matcher = newRouter.matcher; // reset router
			}
		}
	}
);

Vue.use(VueRouterBackButton, { router })

router.beforeEach(appGuard)

export default router
